<template>
  <div class="shopItemDetailOption" :class="{isActiveSubOption: getActiveSubOption}">
    <div class="optionWrapper">
      <button type="button" class="btnCloseOption" @click.stop="close"></button>
      <div class="optionTabs">
        <button
          v-for="(tab, index) in optionTab"
          :key="index"
          type="button"
          class="tabItem"
          :class="{isComplete: isComplete(tab.uniqueId) && !isActive(tab.uniqueId)}"
          :style="isActive(tab.uniqueId) ? getDefaultBtnStyle : getDefaultBtnStyleReverse"
          @click="setActiveTab(tab.uniqueId)">
          <!-- <i v-if="requiredStkr && (tab.requiredStatus !== '0')" :data-status="tab.requiredStatus" class="optionStatus"></i> -->
          <span v-if="requiredStkr && tab.isRequired" :data-status="tab.requiredStatus" class="requiredStkr">{{ locale.required }}</span>
          {{ tab.name[lang] }}
          <span v-if="tab.requiredMessage" class="notranslate">({{ tab.requiredMessage }})</span>
          <span v-else-if="tab.quantityMessage" class="notranslate">({{ tab.quantityMessage }})</span>
        </button>
      </div>
      <Options
        :locale="locale"
        :lang="lang"
        :options="options"
        :cartOptions="cartOptions"
        :shopItemId="shopItemId"
        :activeOptionId="activeOptionId"
        :shopResponsive="shopResponsive"
        class="optionBox" />
      <div class="btns">
        <button v-if="!isAuth"
          type="button"
          class="btn btnCart notranslate"
          :style="getDefaultBtnStyle"
          @click="close">
          {{ locale.confirm }}
        </button>
        <button v-else-if="!isAvailable"
          type="button"
          class="btn btnCart notranslate"
          @click.stop="close">
          {{ locale.not_available }}
        </button>
        <button v-else-if="status"
          type="button"
          class="btn btnCart"
          @click.stop="close">
          {{ status[lang] }}
        </button>
        <button v-else-if="insufficient"
          type="button"
          class="btn btnCart notranslate disabled"
          @click.stop="close">
          {{ locale.insufficient_quantity }}
        </button>
        <button v-else-if="categoryItemLimit"
          type="button"
          class="btn btnCart notranslate disabled"
          @click.stop="close">
          {{ categoryItemLimit }}
        </button>
        <button v-else-if="timeIsExpired"
          type="button"
          class="btn btnCart notranslate disabled"
          @click.stop="close">
          {{ locale.over_order_time }}
        </button>
        <button v-else
          type="button"
          class="btn btnCart notranslate"
          :style="getDefaultBtnStyle"
          :disabled="isApplyDisabled"
          @click="apply">
          {{ locale.complete_select }}
        </button>
      </div>
    </div>
    <ToastMessage v-if="toastMessage"
      :locale="locale"
      :message="toastMessage"
      :dur="toastDuration"
      @close="setToastMessage(null)" />
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import regExp from '@/common/regExp'
import moment from 'moment/moment'
import UNIQUE from '@/common/unique'
import Options from './Options'
import ItemQuantity from './ItemQuantity'
import AvailableTable from '@/components/Util/AvailableTable'
import ToastMessage from '@/components/Util/ToastMessage'

export default {
  name: 'shopItemDetailOptions',
  props: [
    'locale',
    'lang',
    'shopResponsive',
    'isAvailable',
    'status',
    'isValid',
    'shopItemId',
    'detailOption',
    'cartOptions',
    'insufficient',
    'categoryItemLimit',
    'timeIsExpired'
  ],
  components: {
    Carousel,
    Slide,
    Options,
    ItemQuantity,
    AvailableTable,
    ToastMessage
  },
  computed: {
    requiredStkr () {
      const shopPageId = this.$route.params.shopPageId
      const shopSettings = this.$store.getters['shop/getShopSettings'](shopPageId)
      return shopSettings && !shopSettings.hiddenOptionRequirement
    },
    options () {
      return this.$store.getters['shop/getDetailOptionArray']
    },
    optionTab () {
      const options = this.options
      return options.map(item => {
        return {
          ...item,
          quantityMessage: this.getQuantityMessage(item),
          requiredMessage: this.getRequiredMessage(item),
          requiredStatus: this.getRequiredStatus(item)
        }
      })
    },
    getActiveSubOption () {
      return this.$store.getters['shop/getActiveSubOption']
    },
    getDefaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    getDefaultBtnStyleReverse () {
      return this.$store.getters['common/getDefaultBtnStyleReverse']
    },
    isAuth () {
      const isAuth = this.$store.getters['authentication/isAuth']
      return isAuth
    },
    isApplyDisabled () {
      if (!this.isAuth || !this.isAvailable) return true
      // passOptionItem이면 클릭은 허용하고, apply 안에서 다음 탭 이동 처리
      if (this.passOptionItem) {
        return !this.isOptionValidById(this.activeOptionId)
      }
      // 일반 케이스는 기존처럼 전체 valid여야 함
      return !this.isValid
    },
    getDetailItemInfo () {
      const shopItemId = this.shopItemId
      const getItemProperty = this.$store.getters['shop/getItemProperty']
      return getItemProperty && getItemProperty(shopItemId)
    },
    firstOptionValid () {
      const getDetailOptions = this.$store.getters['shop/getDetailOptions']
      const firstOption = this.options[0].uniqueId
      return getDetailOptions && getDetailOptions[firstOption] && getDetailOptions[firstOption].isValid
    },
    passOptionItem () {
      return this.getDetailItemInfo && this.getDetailItemInfo.passFirstOption
    }
  },
  watch: {
    firstOptionValid: {
      immediate: true,
      handler (isValid) {
        if (this.initialized) return
        const itemOptions = this.options
        const optionLt2 = itemOptions && itemOptions.length > 1
        const passFirstOption = this.passOptionItem
        if (optionLt2 && passFirstOption && isValid && this.options[1] && this.options[1].uniqueId) {
          this.activeOptionId = this.options[1].uniqueId
          this.initialized = true
        }
      }
    },
    isApplyDisabled: {
      immediate: true,
      handler (isDisabled) {
        const isValid = !isDisabled
        if (isValid && this.options.length === 1 && this.passOptionItem) {
          this.apply()
        }
      }
    }
  },
  mounted () {
    if (this.options) {
      const firstOption = this.options[0].uniqueId
      this.activeOptionId = firstOption
    }
  },
  beforeDestroy () {
    this.$store.commit('shop/setActiveSubOption', null)
  },
  data () {
    return {
      initialized: false,
      activeOptionId: '',
      toastMessage: null,
      toastDuration: 2000,
    }
  },
  methods: {
    getQuantityMessage (item) {
      const min = item.min
      const max = item.max
      return  min === max
        ? this.locale.shop_condition_quantity_specific.replace('{var}', max) // N개 선택
        : this.locale.shop_condition_quantity_range.replace('{min}', min).replace('{max}', max) // N~M개 선택
    },
    getRequiredMessage (item) {
      const isRequired = item.isRequired
      const uniqueId = item.uniqueId
      const detailOption = this.detailOption[uniqueId]
      return this.getActiveSubOption
        ? this.locale.option_select
        : isRequired
          ? detailOption && detailOption.isValid ? this.locale.complete_select : ''
          : detailOption && detailOption.isValid && detailOption.optionItems.length > 0 ? this.locale.complete_select : ''
    },
    getRequiredStatus (item) {
      const isRequired = item.isRequired
      const uniqueId = item.uniqueId
      const detailOption = this.detailOption[uniqueId]
      let status = 0 // 선택사항(필수아님)
      if (isRequired) status = 1 // 필수사항
      if (isRequired && detailOption && detailOption.isValid) status = 2 // 필수사항 선택완료
      return `${status}`
    },
    setActiveTab (uniqueId) {
      this.activeOptionId = uniqueId
      this.$store.commit('shop/setActiveSubOption', null)
    },
    isActive (uniqueId) {
      return this.activeOptionId === uniqueId
    },
    isComplete (uniqueId) {
      const itemOptions = this.options
      const optionLt2 = itemOptions && itemOptions.length > 1
      const detailOption = this.detailOption
      const isOptionValid = detailOption && detailOption[uniqueId] && detailOption[uniqueId].isValid
      return optionLt2 && isOptionValid
    },
    isOptionValidById (uniqueId) {
      return !!(
        this.detailOption &&
        this.detailOption[uniqueId] &&
        this.detailOption[uniqueId].isValid === true
      )
    },
    setToastMessage (message, dur) {
      this.toastMessage = null
      this.toastMessage = message
      this.toastDuration = dur || 2000
    },
    getNextInvalidOptionInfo () {
      const options = this.options || []
      const activeId = this.activeOptionId

      if (!options.length) {
        return {
          targetId: null,
          wrapped: false
        }
      }

      const currentIndex = options.findIndex(item => item.uniqueId === activeId)
      if (currentIndex === -1) {
        return {
          targetId: null,
          wrapped: false
        }
      }

      const isAllValid = options.every(item => this.isOptionValidById(item.uniqueId))
      if (isAllValid) {
        return {
          targetId: null,
          wrapped: false
        }
      }

      // 현재 다음부터 끝까지
      for (let i = currentIndex + 1; i < options.length; i++) {
        const uniqueId = options[i].uniqueId
        if (!this.isOptionValidById(uniqueId)) {
          return {
            targetId: uniqueId,
            wrapped: false
          }
        }
      }

      // 처음부터 현재 전까지 = 되감기
      for (let i = 0; i < currentIndex; i++) {
        const uniqueId = options[i].uniqueId
        if (!this.isOptionValidById(uniqueId)) {
          return {
            targetId: uniqueId,
            wrapped: true
          }
        }
      }

      // 현재 탭 자체가 아직 invalid인 경우
      if (!this.isOptionValidById(activeId)) {
        return {
          targetId: activeId,
          wrapped: false
        }
      }

      return {
        targetId: null,
        wrapped: false
      }
    },
    close ($event) {
      this.$emit('close', $event)
    },
    apply (e) {
      if (e) e.stopPropagation()
      if (this.isApplyDisabled) return

      // passOptionItem인 경우:
      // 전부 valid가 아니면 다음 invalid 탭으로 이동
      if (this.passOptionItem) {
        const { targetId, wrapped } = this.getNextInvalidOptionInfo()

        if (targetId) {
          const targetOption = this.options.find(item => item.uniqueId === targetId)

          if (wrapped && targetOption) {
            const itemName = targetOption.name[this.lang]
            const message = this.locale.message_please_select_option_item.replace('{var}', itemName)
            this.setToastMessage(message)
          }

          this.activeOptionId = targetId
          this.$store.commit('shop/setActiveSubOption', null)
          return
        }
      }

      this.$emit('applyOption')
    }
  }
}
</script>

<style lang="scss" scoped>
.shopItemDetailOption {
  .requiredStkr {
    margin-left: 0;
    margin-right: 4px;
  }
}
</style>
